import api from './httpService';

export const addBranchService = async (payload: any) => {
    const response = await api.post('/branch', payload); // assuming you're using axios
    return response.data;
};

export const getBranchService = async () => {
    const response = await api.get("/branch")
    return response.data;
}
export const updateBranchService = async (id: string, data: any) => {
    const response = await api.put(`/branch/${id}`, data); // Make sure data contains what to update
    return response.data;
};
